module.exports = __webpack_public_path__ + "img/ics_f_warning_circle.f93d4d1b.svg";